
// import {HrmsEmployeeDetailsDto} from "@gtpl/shared-models/masters"
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {SalesPersonDto} from './sales-person.dto'

export class SalesPersonResponseModel extends GlobalResponseObject{
    data?: SalesPersonDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProductDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SalesPersonDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}